export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12665.e93408bc.jpg";